import React from "react";
import {LucideCheck} from "lucide-react";

// Shared row for permission and group toggles. A checkbox before the label conveys the state:
//  - checked, filled green   => granted directly (or a group member)
//  - checked, outlined green => inherited from a group (permissions only)
//  - unchecked               => not granted / not a member
export default function ToggleRow(props: {
    label: React.ReactNode,
    active: boolean,
    outlined?: boolean,
    badge?: React.ReactNode,
    onClick?: () => void,
    title?: string
}) {
    return (
        <button
            onClick={props.onClick}
            title={props.title}
            className="w-full flex items-center gap-2.5 rounded-md px-3 py-1.5 text-sm text-left border border-neutral-700 bg-neutral-800 hover:bg-neutral-700 transition-colors">
            <Checkbox active={props.active} inherited={props.outlined ?? false}/>
            <span className="truncate flex-grow text-neutral-200">{props.label}</span>
            {props.badge && <span className="flex items-center gap-1 flex-shrink-0">{props.badge}</span>}
        </button>
    )
}

function Checkbox(props: { active: boolean, inherited: boolean }) {
    if (props.active) {
        return (
            <span className="flex-shrink-0 size-4 rounded flex items-center justify-center bg-green-600 border border-green-600">
                <LucideCheck size={12} strokeWidth={3} className="text-white"/>
            </span>
        )
    }
    if (props.inherited) {
        return (
            <span className="flex-shrink-0 size-4 rounded flex items-center justify-center border border-green-500 text-green-400">
                <LucideCheck size={12} strokeWidth={3}/>
            </span>
        )
    }
    return <span className="flex-shrink-0 size-4 rounded border border-neutral-500"/>
}
